import routes from './routes';

export const MEDIA_VIDEO_ALBUM_ROUTES: Record<number, string> = {
  2: routes.media.videoFaces.root,
  3: routes.media.videoAboutExport.root,
  4: routes.media.videoWhatBuy.root,
  5: routes.media.videoLifeHacks.root,
};

export const MEDIA_VIDEO_ALBUM_DEFAULT_ID: Record<string, number> = {
  [routes.media.videoFaces.root]: 2,
  [routes.media.videoLifeHacks.root]: 5,
  [routes.media.videoWhatBuy.root]: 4,
  [routes.media.videoAboutExport.root]: 3,
};

export const getMediaVideoAlbumRoute = (albumId: number): string => (
  MEDIA_VIDEO_ALBUM_ROUTES[albumId] || routes.media.videoAlbums.root
);

export const MEDIA_RESERVED_SLUGS = [
  'news',
  'gallery',
  'articles',
  'special-projects',
  'technological-tours',
  'video-albums',
  'video-faces',
  'video-lifehacks',
  'video-what-buy',
  'video-about-export',
];

export const MEDIA_RESERVED_REDIRECTS: Record<string, string> = {
  news: routes.media.news.root,
  gallery: routes.media.gallery.root,
  articles: routes.media.articles.root,
  'special-projects': routes.media.specProjects.root,
  'technological-tours': routes.media.techTours.root,
  'video-albums': routes.media.videoAlbums.root,
  'video-faces': `${routes.media.videoFaces.root}/2`,
  'video-lifehacks': `${routes.media.videoLifeHacks.root}/5`,
  'video-what-buy': `${routes.media.videoWhatBuy.root}/4`,
  'video-about-export': `${routes.media.videoAboutExport.root}/3`,
};
